// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"TaskPlan_AddNewGoalPop__4BZna","modalBody":"TaskPlan_modalBody__61BhJ","formControl":"TaskPlan_formControl__H-gCW","add":"TaskPlan_add__XXp29"};